/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../model/device_profile_link';
import '../model/shared/device_profile_link';
import '../../../../devices/external/search_devices_query';
import '../model/shared/device';
import './status';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "LinkDeviceProfilesV2Request": {
                        "fields": {
                          "links": {
                            "type": ".squareup.devicesettings.profiles.v2.model.DeviceProfileLink",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "deviceProfileLinks": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileLink",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "batchLink": {
                            "type": ".squareup.devicesettings.profiles.v2.message.BatchLinkDevicesToProfile",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "BatchLinkDevicesToProfile": {
                        "fields": {
                          "query": {
                            "type": ".squareup.connect.v2.SearchDevicesQuery",
                            "id": 1,
                            "rule": "optional"
                          },
                          "device": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.Device",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "deviceProfileId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "LinkDeviceProfilesV2Response": {
                        "fields": {
                          "status": {
                            "type": ".squareup.devicesettings.profiles.v2.message.Status",
                            "id": 1,
                            "rule": "optional"
                          },
                          "pairedLinks": {
                            "type": ".squareup.devicesettings.profiles.v2.model.DeviceProfileLink",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "unpairedLinks": {
                            "type": ".squareup.devicesettings.profiles.v2.model.DeviceProfileLink",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "linkedProfileLinks": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileLink",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "unlinkedProfileLinks": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileLink",
                            "id": 5,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.LinkDeviceProfilesV2Request && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.BatchLinkDevicesToProfile && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.LinkDeviceProfilesV2Response) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE LinkDeviceProfilesV2Request @ squareup/devicesettings/profiles/v2/message/link_device_profiles.proto at 15:1
 */
export const LinkDeviceProfilesV2Request = $root.lookupType('squareup.devicesettings.profiles.v2.message.LinkDeviceProfilesV2Request');
fixType(LinkDeviceProfilesV2Request);
Builder.createAndAttachToType(LinkDeviceProfilesV2Request);
/**
 * SOURCE BatchLinkDevicesToProfile @ squareup/devicesettings/profiles/v2/message/link_device_profiles.proto at 21:1
 */
export const BatchLinkDevicesToProfile = $root.lookupType('squareup.devicesettings.profiles.v2.message.BatchLinkDevicesToProfile');
fixType(BatchLinkDevicesToProfile, {
  deviceProfileId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BatchLinkDevicesToProfile);
/**
 * SOURCE LinkDeviceProfilesV2Response @ squareup/devicesettings/profiles/v2/message/link_device_profiles.proto at 27:1
 */
export const LinkDeviceProfilesV2Response = $root.lookupType('squareup.devicesettings.profiles.v2.message.LinkDeviceProfilesV2Response');
fixType(LinkDeviceProfilesV2Response);
Builder.createAndAttachToType(LinkDeviceProfilesV2Response);